/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * PageLoader - the site's one loading screen (logo and animated bars).
 *
 * Used while a lazy page loads and by every page that is only a step on the
 * way somewhere else (sign-in return pages, the forum hand-off, sign-out).
 * Those pass a statusLabel so a screen reader says what is happening; the
 * white `.auth-spinner` they used before was drawn for the blue Sign in
 * buttons and was invisible on a white card.
 */

import React from "react";
import LoadingSplash from "./LoadingSplash";

interface PageLoaderProps {
  /** Spoken to screen readers while the page waits, e.g. "Logging you in…". */
  statusLabel?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ statusLabel }) => (
  <LoadingSplash statusLabel={statusLabel} />
);

export default PageLoader;
